export default __webpack_public_path__ + "media/color/html-bc9ef668.svg";